/**
 * Common set of functions for refreshing and deleting appointments from local
 */
export const refresh = {
  /**
   * Function to delete from local
   * @param {Object} appointments
   * @param {Object} context
   */
  deleteRequired(
    appointments,
    context,
    selectedProviderId,
    deleteOrCancel = "delete"
  ) {
    const distinctYears = [];

    // Step 1: Remove the appointment from both the appointment details and list of appointment
    for (let i = 0; i < appointments.length; i++) {
      const date = appointments[i]["app_date"];
      const id = isNaN(appointments[i]["id"])
        ? 0
        : parseInt(appointments[i]["id"]);

      if (deleteOrCancel === "cancel" || deleteOrCancel === "un-cancel") {
        context.commit("cancelFromDetails", { id, cancelOrUn: deleteOrCancel });
        context.commit("cancelFromAppointmentList", {
          date,
          id,
          cancelOrUn: deleteOrCancel
        });
      } else {
        context.commit("deleteFromDetails", id);
        context.commit("removeFromAppointmentList", {
          date,
          id
        });
      }

      const year = date.split("-")[0];
      if (distinctYears.indexOf(year) === -1) {
        distinctYears.push(parseInt(year));
      }
    }

    // Step 2: Refresh the years to check if last appointment has also been deleted
    context.commit("refreshYears", {
      years: distinctYears,
      selectedProviderId
    });

    // Step 3: Get the yearly appointments
    context.dispatch("getYearlyAppointments");
  },

  /**
   * Function to refresh dates
   * @param {Array} dates
   * @param {Object} context
   */
  refreshRequired(dates, context, selectedProviderId, pushYear = true) {
    for (let i = 0; i < dates.length; i++) {
      context.commit("refreshDate", { date: dates[i], selectedProviderId });
      if (pushYear) {
        context.commit("pushAppointmentYears", {
          date: dates[i],
          selectedProviderId
        });
      }
    }

    context.dispatch("getYearlyAppointments");
    context.dispatch("getAppointmentDetails");
  }
};
